<template lang="pug">
section.mobile-login
  .login-field
    .input-group
      .input-group-prepend
        .input-group-text
          i.fas.fa-user
      input#username.form-control(v-model="username" type="text" :placeholder="$t('ui.account_id')" autofocus autocomplete="off" maxlength="20")
  .login-field
    .input-group
      .input-group-prepend
        .input-group-text
          i.fas.fa-key
      input#password.form-control(v-model="password" type="password" :placeholder="$t('ui.password')" autocomplete="off" maxlength="20" @keyup.enter="login")
  .invalid-feedback(v-if="feedback.password" style="display:block") {{ feedback.password }}
  .invalid-feedback(v-if="feedback.username" style="display:block") {{ feedback.username }}
  .invalid-feedback(v-if="result" style="display:block") {{ $t("error." + result) }}
  .btn-wrapper.d-flex
    .lang-wrap
      //- select.langpicker
      //-   option.test(value='en' data-thumbnail='images/landing/lang/en.svg') English
      //-   option.test(value='cn' data-thumbnail='images/landing/lang/cn_simplify.svg') &#x7B80;&#x4F53;&#x4E2D;&#x6587;
      //-   option.test(value='cn' data-thumbnail='images/landing/lang/cn_tranditional.svg') &#x7E41;&#x4F53;&#x4E2D;&#x6587;
      //-   option.test(value='bm' data-thumbnail='images/landing/lang/bm.svg') B.Malaysia
      //-   option.test(value='jp' data-thumbnail='images/landing/lang/jp.svg') Japan
      //-   option.test(value='vn' data-thumbnail='images/landing/lang/vn.svg') Ti&#x1EBF;ng Vi&#x1EC7;t
      //-   option.test(value='vn' data-thumbnail='images/landing/lang/th.svg') &#xE20;&#xE32;&#xE29;&#xE32;&#xE44;&#xE17;&#xE22;
      //-   option.test(value='id' data-thumbnail='images/landing/lang/id.svg') Indonesian
      //-   option.test(value='id' data-thumbnail='images/landing/lang/kr.svg') &#xD55C;&#xAD6D;&#xC5B4;
      .lang-select
        .btn-select
          li
            img(:src="'/images/lang/' + language + '.svg?v=12'")
            //- span {{ $t("language." + language) }}
        .lang-dropdown-wrap
          ul#lang-dropdown-list-mobile
            li(v-for="item in languageList" @click="setLanguage(item)")
              img(:src="'/images/lang/' + item + '.svg?v=12'")
              span {{ $t("language." + item) }}
    //- button.login-btn.flex-grow-1 {{ $t('ui.login') }}
    SpinButton(:text="$t('ui.login')" :loading="feedback.loading" css="login-btn flex-grow-1" @click="login")

//- #login-modal.modal.fade.login-modal(tabindex="-1" role="dialog" aria-labelledby="loginLabel" aria-hidden="true")
//-   .modal-dialog(role="document")
//-     .modal-content
//-       .banner
//-         .text
//-           h1 {{ $t("ui.welcome") }}
//-           //- p sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.
//-           //- small {{ title }} ({{ version }})
//-       .modal-body
//-         .login-field
//-           label {{ $t("ui.display_language") }}:
//-           .input-group
//-             .lang-select
//-               .btn-select
//-                 li
//-                   img(:src="'/images/lang/' + language + '.svg?v=12'")
//-                   span {{ $t("language." + language) }}
//-               .lang-dropdown-wrap
//-                 ul#lang-dropdown-list
//-                   li(v-for="item in languageList" @click="setLanguage(item)")
//-                     img(:src="'/images/lang/' + item + '.svg?v=12'")
//-                     span {{ $t("language." + item) }}
//-           .login-field.mt-3
//-             label {{ $t("ui.account_id") }}:
//-             .input-group
//-               .input-group-prepend
//-                 .input-group-text
//-                   i.fas.fa-user
//-               input#username.form-control(v-model="username" type="text" :placeholder="$t('ui.account_id')" autofocus autocomplete="off" maxlength="20")
//-               .invalid-feedback(v-if="feedback.username") {{ feedback.username }}
//-           .login-field
//-             label {{ $t("ui.password") }}:
//-             .input-group
//-               .input-group-prepend
//-                 .input-group-text
//-                   i.fas.fa-key
//-               input#password.form-control(v-model="password" type="password" :placeholder="$t('ui.password')" autocomplete="off" maxlength="20" @keyup.enter="login")
//-               .invalid-feedback(v-if="feedback.password") {{ feedback.password }}
//-           .login-field.text-right.pt-2
//-             SpinButton(:text="$t('ui.login')" :loading="feedback.loading" css="login-btn" @click="login")
//-         .modal-footer-sticky.w-100.d-flex.align-items-center.justify-content-center(v-if="result")
//-           span.text-capitalize.animated.flash.text-danger.text-center {{ $t("error." + result) }}
</template>


<script>
import { required, alphaNum } from "vuelidate/lib/validators";
import config from "@/config";
import errors from "@/errors";
import SpinButton from "@/components/ui/SpinButton";
import { EventBus } from "@/library/_event-bus.js";

export default {
  components: {
    SpinButton
  },
  data() {
    return {
      languageList: ["en", "cn", "vi", "th", "id", "kr", "jp"],
      username: "",
      password: "",
      feedback: {
        username: "",
        password: "",
        loading: false,
        timeout: null
      },
      result: ""
    };
  },
  computed: {
    language() {
      return this.$store.getters.language;
    },
    version() {
      return config.appVersion;
    },
    title() {
      return config.appTitle;
    }
  },
  watch: {
    result(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.result = "";
        }, 10000);
      }
    }
  },
  validations: {
    username: {
      required
    },
    password: {
      required
    }
  },
  mounted() {
    $(".btn-select").click(function() {
      $(".lang-dropdown-wrap").toggle();
    });

    // $("#login-modal").on("shown.bs.modal", function() {
    //   $("#username").trigger("focus");
    // });
  },
  methods: {
    setLanguage(lang) {
      this.$store.dispatch("layout/setLanguage", lang);
      $(".lang-dropdown-wrap").toggle();
    },
    reset() {
      this.feedback.username = "";
      this.feedback.password = "";
    },
    login() {
      // must invoke touch to validate the errors
      this.$v.$touch();
      clearTimeout(this.feedback.timeout);
      if (!this.$v.$invalid) {
        this.feedback.loading = true;
        this.reset();
        this.$store.dispatch("layout/reset");
        this.$store.dispatch("user/doLogin", { username: this.username, password: this.password }).then(
          res => {
            this.feedback.loading = false;
            if (res.success) {
              this.feedback.loading = true;
              this.$store.dispatch("user/getBalance").then(
                res => {
                  this.feedback.loading = false;
                  if (res.success) {
                    // $("#login-modal").modal("hide");
                    this.$store.dispatch("layout/setRadarId", null);
                    // this.$store.dispatch("layout/setSingleBetting", {property: "quickBet", value: false});
                    EventBus.$emit("INVALIDATE");
                    setTimeout(() => {
                      var isMMO = this.$store.getters.mmoMode;
                      if(["localhost","gsportm.joyful88.com"].includes(window.location.hostname)) {
                        this.$router.push("/lobby");
                      } else {
                        if(isMMO) {
                          let domain = window.location.hostname
                          let accountID = this.$store.getters.accountId
                          let sessionToken = this.$store.getters.sessionToken
                          window.location.href = "https://" + domain.replace("m.", "") + "?&u=" + accountID + "&st=" + sessionToken
                        } else {
                          this.$router.push("/lobby");
                        }
                      }
                    }, 500);
                  } else {
                    this.result = res.status;
                    // if (this.$helpers.handleFeedback(res.status)) {
                    // }
                  }
                },
                err => {
                  this.feedback.loading = false;
                  this.result = res.status;
                  // if (this.$helpers.handleFeedback(err.status)) {
                  // }
                }
              );
            } else {
              this.result = res.status;
              // this.$helpers.handleFeedback(res.status);
            }
          },
          err => {
            this.feedback.loading = false;
            this.result = err.status;
            // this.$helpers.handleFeedback(err.status);
          }
        );
      } else {
        this.feedback.loading = false;
        this.reset();
        if (!this.$v.username.required) {
          this.feedback.username = this.$t("error.usernameRequired");
        }

        // if (!this.$v.username.alphaNum) {
        //   this.feedback.username = this.$t("error.alphaNumOnly");
        // }

        if (!this.$v.password.required) {
          this.feedback.password = this.$t("error.passwordRequired");
        }
      }

      // reset the error message after 10 s
      this.feedback.timeout = setTimeout(() => {
        this.$v.$reset();
        this.reset();
      }, 10000);
    }
  }
};
</script>